import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, SettingsIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-navy" data-id="element-81" data-mp="s9zzhikkb8n9">
      <div className="h-1 w-full bg-electric shadow-glow" aria-hidden="true" data-id="element-82" data-mp="ncq13df73mna" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-83" data-mp="3d1ikzavvpeny">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-electric/60 bg-industrial px-4 py-2 font-display text-sm font-bold uppercase tracking-[.14em] text-silver shadow-glow" data-id="element-84" data-mp="3cz5ug9c21vza">
          <SettingsIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-85" data-mp="39cfkx0rpn1u1" /> {productBrand}
        </motion.p>

        

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-4xl" data-id="element-86" data-mp="30iaziwvciilw">
          <img src={productImage} alt="Mechanical Engineering Professional Edition: six volumes covering engineering fundamentals, materials, machine elements, thermodynamics, manufacturing processes and industrial machinery, plus five bonus resources" className="mx-auto w-full drop-shadow-mockup" data-id="element-87" data-mp="2qhqvxnkct20i" />
        </motion.div>

        <div className="mt-8" data-id="element-88" data-mp="s21k8hdb6o2m">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-89" data-mp="s3351dk4moxj">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-sm font-semibold text-silver" data-id="element-90" data-mp="ic873bxiq0w9">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-electric/40 bg-industrial px-3 py-2" data-id="element-91" data-mp="deyitzlv7va0">
              <Icon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-92" data-mp="1622irq63pjex" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}